//extracted by mini-css-extract-plugin
export default {"sparkLogo":"HeaderLogoSection_sparkLogo__UF8zU"};;